import get from "./get.api";
import getListing from "./get-listing.api";
import getCompanies from "./get-companies.api";
import create from "./create.api";
import update from "./update.api";
import setStatus from "./set-status.api";
import remove from "./delete.api";
import getStructure from "./get-structure.api";

const bundlesApi = {
  get,
  getListing,
  getCompanies,
  create,
  update,
  setStatus,
  remove,
  getStructure,
};

export default bundlesApi;
